/* ================================
GLOBAL CSS
================================ */
import "./App.css";
import { useEffect, useState } from "react";
/* ================================
REACT ROUTER
================================ */
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./Client/Pages/ScrollToTop";

/* ================================
REACT QUERY (CORE ONLY)
================================ */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SearchDesigns from "./Client/Pages/SearchDesigns";
/* ================================
CLIENT IMPORTS
================================ */
import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";
import Home from "./Client/Pages/Home";
import Contact from "./Client/Pages/Contact";
import Wishlist from "./Client/Pages/Wishlist";

import { MenuProvider } from "./Client/Pages/MenuContext";
import Category from "./Client/Pages/Category";

/* ================================
LAYOUT HANDLER
================================ */

import Product from "./Client/Pages/Product";
import News from "./Client/Pages/News";
import PaymentPage from "./Client/Pages/PaymentPage";
import LatestDesign from "./Client/Pages/LatestDesign";
import Howtouse from "./Client/Pages/Howtouse";
import Ads from "./Client/Pages/Ads";

import Offer from "./Client/Pages/Offer";
import Cart from "./Client/Pages/Cart";
import MyOrders from "./Client/Pages/Orders";
import OrderDetails from "./Client/Pages/Orderdtails";

import ChangePassword from "./Client/Pages/ChangePasssword";
import Policy from "./Client/Pages/Policy";
import UsefulLink from "./Client/Pages/UsefulLink";
import Balance from "./Client/Pages/Balance";

import Services from "./Client/Pages/Services";
import Gallery from "./Client/Pages/Gallery";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes cache
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function Layout() {
  const location = useLocation();
  const isUser = location.pathname.startsWith("/user");
  const isAdmin = location.pathname.startsWith("/admin");

  if (!isUser && !isAdmin) {
    return (
      <MenuProvider>
        <QueryClientProvider client={queryClient}>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/category" element={<Category />} />
            <Route path="/product" element={<Product />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/payment-methods" element={<PaymentPage />} />
            <Route path="/search" element={<SearchDesigns />} />
            <Route path="/latest-design" element={<LatestDesign />} />
            <Route path="/news" element={<News />} />
            <Route path="/ads" element={<Ads />} />
            <Route path="/how-to-use" element={<Howtouse />} />
            <Route path="/Service" element={<Services />} />
            <Route path="/offers" element={<Offer />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/myorders" element={<MyOrders />} />
            <Route path="/order-details" element={<OrderDetails />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/useful-links" element={<UsefulLink />} />
            <Route path="/balance" element={<Balance />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route
              path="/change-password/:userid"
              element={<ChangePassword />}
            />
          </Routes>
          <Footer />
        </QueryClientProvider>
      </MenuProvider>
    );
  }
}

function App() {
  useEffect(() => {
    let timer;

    const logout = () => {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = "/";
    };

    const resetTimer = () => {
      clearTimeout(timer);

      timer = setTimeout(
        () => {
          logout();
        },
        5 * 60 * 60 * 1000,
      ); // 5 hours
    };

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timer);
    };
  }, []);
  const [user, setUser] = useState(null);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);
  useEffect(() => {
    const syncUser = () => {
      const storedUser = localStorage.getItem("user");
      setUser(storedUser ? JSON.parse(storedUser) : null);
    };

    window.addEventListener("storage", syncUser);

    return () => {
      window.removeEventListener("storage", syncUser);
    };
  }, []);
  useEffect(() => {
    let timer;

    const reset = () => {
      clearTimeout(timer);

      timer = setTimeout(
        () => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          window.location.href = "/";
        },
        2 * 60 * 60 * 1000,
      ); // 2 hours
    };

    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((e) => window.addEventListener(e, reset));

    reset();

    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      clearTimeout(timer);
    };
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout user={user} setUser={setUser} />
    </BrowserRouter>
  );
}

export default App;
